import { Student } from '../../shared-components/student/student.model';

export class DisciplineReferralStudent extends Student {

    // Static Properties
    static InvolvementTypes: {[key: number]: string} = {
        1: 'Offender',
        2: 'Victim',
        3: 'Witness'
    };

    // Static Properties
    static V9InvolvementTypes: {[key: number]: string} = {
        2: 'Offender',
        0: 'Victim',
        1: 'Witness'
    };
    // Server Properties
    IncidentComments: string;
    DeletedFromReferral = false;
    isSelected = false;
    StudentId: number;
    InvolvingType: string;
    CanSee: boolean;
    StudentsToReferralsId: number;

    // Class Functions
    constructor() {
        super();
        this.InvolvementType = Object.keys(DisciplineReferralStudent.InvolvementTypes)[0];
    }

    // Methods
}
